import { OperationVariables, QueryTuple } from '@apollo/client';
import { getApolloLink, useApolloLazyQuery, useCookie } from '@netfront/common-library';

import { IUseMuriquiLazyQueryInputVariables } from './useMuriquiLazyQuery.interfaces';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useMuriquiLazyQuery = <TData = any, TVariables extends OperationVariables = OperationVariables>({
  apolloLink,
  options,
  query,
  token,
}: IUseMuriquiLazyQueryInputVariables<TData, TVariables>): QueryTuple<TData, TVariables> => {
  const { getAccessTokenCookie, getTemporaryTokenCookie } = useCookie();

  const accessToken = getAccessTokenCookie();
  const temporaryToken = getTemporaryTokenCookie();

  const authenticationLink = getApolloLink({
    apiName: 'muriqui',
    token: token ?? accessToken ?? temporaryToken,
  });

  return useApolloLazyQuery({
    apiName: 'muriqui',
    apolloLink: apolloLink ?? authenticationLink,
    options,
    query,
  });
};

export { useMuriquiLazyQuery };
